/* =========================================================
   GlazyBoo Custom Cart Controller v35
   Full custom cart, no native Symmetry drawer open/close.
   - Sitewide A/B: overlay_cart vs cart_page
   - Intercepts native add-to-cart forms before page POST
   - Renders its own cart UI from /cart.js
   ========================================================= */
(function () {
  var KEY = 'gb_cart_experience_v32';
  var VERSION = 'v90-ad-safe-button-routing';
  var LEGACY_KEYS = [
    'glazyboo_cart_experience_variant_v1',
    'gb_cart_experience_v23',
    'gb_cart_experience_v25',
    'gb_cart_experience_v28',
    'gb_cart_experience_v29',
    'gb_cart_experience_v30',
    'gb_cart_experience_v31'
  ];

  var state = {
    cart: null,
    isOpen: false,
    busy: false,
    lastFocused: null,
    timerEndsAt: null,
    pendingFetch: null,
    lastFetchAt: 0,
    lastCartJson: null,
    updatingFailsafeTimer: null,
    compareCache: {},
    historyEntryActive: false
  };

  var BOGO = {
    storageKey: 'glazyboo_bogo_urgency_variant_v1',
    paidVariantIds: [43756305907966, 43756305973502, 43756305940734],
    styles: [
      { label: 'Natural', paidVariantId: 43756305907966, freeVariantId: 54756149723462, image: 'https://cdn.shopify.com/s/files/1/0666/3172/9406/products/Natural.png?v=1671400083' },
      { label: 'Long', paidVariantId: 43756305973502, freeVariantId: 54756149756230, image: 'https://cdn.shopify.com/s/files/1/0666/3172/9406/products/Long.png?v=1671400083' },
      { label: 'Thick', paidVariantId: 43756305940734, freeVariantId: 54756149788998, image: 'https://cdn.shopify.com/s/files/1/0666/3172/9406/products/Thick.png?v=1671400083' }
    ]
  };

  function originalMode() {
    return (window.GlazyBooCartModeOriginal || (window.theme && theme.settings && theme.settings.cart_type) || 'drawer');
  }

  function normalize(v) {
    if (v === 'overlay' || v === 'overlay_cart') return 'overlay_cart';
    if (v === 'page' || v === 'cart_page') return 'cart_page';
    if (v === 'drawer' || v === 'drawer_cart' || v === 'instant_cart' || v === 'native_drawer') return 'drawer_cart';
    return null;
  }

  function setStoredVariant(v) {
    v = normalize(v);
    if (!v) return null;
    try {
      localStorage.setItem(KEY, v);
      LEGACY_KEYS.forEach(function (k) { try { localStorage.removeItem(k); } catch (e) {} });
    } catch (e) {}
    return v;
  }

  function getStoredVariant() {
    try { return normalize(localStorage.getItem(KEY)); } catch (e) { return null; }
  }

  function getVariant() {
    var mode = originalMode();
    var existing = getStoredVariant();

    if (mode === 'overlay') return setStoredVariant('overlay_cart');
    if (mode === 'page') return setStoredVariant('cart_page');
    if (mode === 'drawer') return 'drawer_cart';
    if (mode === 'overlay_ab') {
      if (existing === 'overlay_cart' || existing === 'cart_page') return existing;
      return setStoredVariant(Math.random() < 0.5 ? 'overlay_cart' : 'cart_page');
    }
    return existing || 'cart_page';
  }

  function isCustomMode() {
    var mode = originalMode();
    // Native drawer must stay fully Symmetry/native, no custom ATC interception.
    return mode === 'page' || mode === 'overlay' || mode === 'overlay_ab';
  }

  function isCartPage() {
    var path = (window.location && window.location.pathname ? window.location.pathname : '').replace(/\/$/, '');
    return path === '/cart';
  }

  function shouldLeaveNativeCartPageAlone() {
    // On /cart, let Symmetry/Shopify own quantity minus/plus/remove/update behavior.
    // The custom controller is only for product-page ATC and the overlay UI.
    return isCartPage();
  }

  // Shopify confirmation and reconciliation already finish before navigation.
  var CART_PAGE_REDIRECT_DELAY_MS = 0;
  var ADD_TO_CART_BUTTON_SELECTOR = [
    'button[type="submit"]',
    'input[type="submit"]',
    '[name="add"]',
    '.add-to-cart',
    '[data-add-to-cart]',
    '[data-gb-atc]',
    '.gb-buy-atc',
    '.gb-buy-bundle-action',
    '.gb-sticky-atc__button',
    '.kaching-bundles__button',
    '.kaching-bundles__add-to-cart'
  ].join(', ');
  var REAL_ATC_BUTTON_SELECTOR = [
    '[name="add"]',
    '.add-to-cart',
    '[data-add-to-cart]',
    '[data-gb-atc]',
    '.gb-buy-atc',
    '.gb-buy-bundle-action',
    '.gb-sticky-atc__button',
    '.kaching-bundles__button',
    '.kaching-bundles__add-to-cart',
    'button[type="submit"]',
    'input[type="submit"]'
  ].join(', ');
  var DYNAMIC_CHECKOUT_SELECTOR = [
    '.shopify-payment-button',
    '.shopify-payment-button__button',
    '.shopify-payment-button__more-options',
    '[data-shopify="payment-button"]',
    '[data-testid*="ShopifyPay"]',
    '[data-testid*="Checkout"]',
    '[data-gbcc-dynamic-checkout]'
  ].join(', ');

  function getCartUrl() {
    return (window.theme && theme.routes && theme.routes.cart_url) || '/cart';
  }

  function goToCartPage(delayForTracking) {
    var url = getCartUrl();
    var delay = delayForTracking ? CART_PAGE_REDIRECT_DELAY_MS : 0;
    window.setTimeout(function () {
      window.location.href = url;
    }, delay);
  }

  function isDynamicCheckoutTrigger(el) {
    if (!el || !el.closest) return false;
    return !!el.closest(DYNAMIC_CHECKOUT_SELECTOR);
  }

  function shouldIgnoreAddToCartTrigger(trigger) {
    if (!trigger || !trigger.matches) return false;
    if (isDynamicCheckoutTrigger(trigger)) return true;
    if (trigger.matches('[name="checkout"], [data-gbcc-checkout]')) return true;

    var tagName = (trigger.tagName || '').toUpperCase();
    var type = (trigger.getAttribute('type') || '').toLowerCase();

    // Do not treat ordinary UI buttons inside product forms as Add to Cart.
    // This protects hair color arrows, gallery buttons, option sliders, and app buttons.
    if (tagName === 'BUTTON' && type === 'button' && !trigger.matches(REAL_ATC_BUTTON_SELECTOR)) {
      return true;
    }

    return false;
  }

  function getSubmitterFromEvent(e) {
    if (e && e.submitter) return e.submitter;
    var active = document.activeElement;
    if (active && active.matches && active.matches(ADD_TO_CART_BUTTON_SELECTOR + ', ' + DYNAMIC_CHECKOUT_SELECTOR + ', [name="checkout"]')) {
      return active;
    }
    return null;
  }

  function applyRootClasses() {
    var variant = getVariant();
    document.documentElement.setAttribute('data-glazyboo-cart-experience', variant);
    document.documentElement.classList.toggle('glazyboo-cart-experience-overlay', variant === 'overlay_cart');
    document.documentElement.classList.toggle('glazyboo-cart-experience-page', variant === 'cart_page');
    document.documentElement.classList.toggle('glazyboo-cart-experience-native-drawer', variant === 'drawer_cart');
    document.documentElement.classList.toggle('glazyboo-custom-cart-enabled', isCustomMode());
    if (document.body) {
      document.body.classList.toggle('glazyboo-cart-experience-overlay', variant === 'overlay_cart');
      document.body.classList.toggle('glazyboo-cart-experience-page', variant === 'cart_page');
      document.body.classList.toggle('glazyboo-cart-experience-native-drawer', variant === 'drawer_cart');
      document.body.classList.toggle('glazyboo-custom-cart-open', state.isOpen);
    }
    return variant;
  }

  function formatMoney(cents) {
    cents = Number(cents || 0);
    var moneyFormat = (window.theme && theme.money_format) || '${{amount}}';
    if (window.Shopify && typeof Shopify.formatMoney === 'function') {
      try { return Shopify.formatMoney(cents, moneyFormat); } catch (e) {}
    }
    return '$' + (cents / 100).toFixed(2);
  }

  function escapeHtml(str) {
    return String(str == null ? '' : str).replace(/[&<>'"]/g, function (c) {
      return {'&':'&amp;', '<':'&lt;', '>':'&gt;', "'":'&#39;', '"':'&quot;'}[c];
    });
  }

  function getProductHandleFromItem(item) {
    if (!item) return '';
    if (item.handle) return String(item.handle);
    if (item.product_handle) return String(item.product_handle);
    if (item.url) {
      var m = String(item.url).match(/\/products\/([^\/?#]+)/i);
      if (m && m[1]) return m[1];
    }
    return '';
  }

  function fetchCompareMapForHandle(handle) {
    handle = String(handle || '').trim();
    if (!handle) return Promise.resolve({});

    if (state.compareCache[handle]) return state.compareCache[handle];

    state.compareCache[handle] = fetch('/products/' + encodeURIComponent(handle) + '.js', {
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' },
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) throw new Error('product.js failed: ' + r.status);
        return r.json();
      })
      .then(function (product) {
        var map = {};
        ((product && product.variants) || []).forEach(function (variant) {
          map[String(variant.id)] = Number(variant.compare_at_price || 0);
        });
        return map;
      })
      .catch(function () { return {}; });

    return state.compareCache[handle];
  }

  function hydrateCompareAtPrices(cart) {
    cart = cart || {};
    var items = cart.items || [];
    if (!items.length) return Promise.resolve(cart);

    var byHandle = {};
    items.forEach(function (item) {
      var handle = getProductHandleFromItem(item);
      if (!handle) return;
      byHandle[handle] = true;
    });

    var handles = Object.keys(byHandle);
    if (!handles.length) return Promise.resolve(cart);

    return Promise.all(handles.map(fetchCompareMapForHandle)).then(function (maps) {
      var merged = {};
      handles.forEach(function (handle, i) {
        merged[handle] = maps[i] || {};
      });

      items.forEach(function (item) {
        var linePrice = Number(item.final_line_price || item.line_price || 0);
        var originalLine = Number(item.original_line_price || linePrice || 0);
        var originalUnit = Number(item.original_price || item.final_price || item.price || 0);
        var qty = Number(item.quantity || 0) || 1;
        var handle = getProductHandleFromItem(item);
        var compareUnit = Number((merged[handle] && merged[handle][String(item.variant_id)]) || 0);
        var compareLine = compareUnit > 0 ? compareUnit * qty : 0;

        item._gbcc_compare_unit_price = Math.max(originalUnit, compareUnit || 0);
        item._gbcc_compare_line_price = Math.max(originalLine, compareLine || 0);
      });

      return cart;
    }).catch(function () {
      return cart;
    });
  }

  function isGiftItem(item) {
    return !!(item && item.properties && String(item.properties._glazyboo_bogo_gift) === 'true');
  }

  function isEligibleBogoPaidItem(item) {
    /* Lash BOGO owns lash lines only. Never let a Halo bundle line enter lash reconciliation. */
    return !!item &&
      BOGO.paidVariantIds.indexOf(Number(item.variant_id)) !== -1 &&
      !isGiftItem(item) &&
      !haloBundleRole(item);
  }


  function haloBundleRole(item) {
    if (!item || !item.properties) return '';
    return String(item.properties._GlazyBoo_bundle || '').trim();
  }

  function haloBundleId(item) {
    if (!item || !item.properties) return '';
    return String(item.properties._GlazyBoo_halo_bundle_id || '').trim();
  }

  function isHaloBundlePaidItem(item) {
    /* Halo reconciliation must never touch the eyelash gift rows. */
    return !isGiftItem(item) && haloBundleRole(item) === 'Wavy paid pair';
  }

  function isHaloBundleFreeItem(item) {
    /* Halo reconciliation must never touch the eyelash gift rows. */
    return !isGiftItem(item) && haloBundleRole(item) === 'Straight free pair';
  }

  function getHaloBundleData(cart) {
    var result = {
      freeByPaidKey: {},
      freeKeyMap: {},
      paidQty: 0
    };
    var paidById = {};
    var freeById = {};
    var legacyPaid = [];
    var legacyFree = [];

    (cart && cart.items ? cart.items : []).forEach(function (item) {
      if (!isHaloBundlePaidItem(item) && !isHaloBundleFreeItem(item)) return;

      if (isHaloBundlePaidItem(item)) {
        result.paidQty += Math.max(0, Number(item.quantity || 0));
      }

      var bundleId = haloBundleId(item);
      if (!bundleId) {
        if (isHaloBundlePaidItem(item)) legacyPaid.push(item);
        if (isHaloBundleFreeItem(item)) legacyFree.push(item);
        return;
      }

      if (isHaloBundlePaidItem(item)) paidById[bundleId] = item;
      if (isHaloBundleFreeItem(item)) freeById[bundleId] = item;
    });

    Object.keys(paidById).forEach(function (bundleId) {
      var paid = paidById[bundleId];
      var free = freeById[bundleId];
      if (!paid || !free) return;
      result.freeByPaidKey[String(paid.key)] = free;
      result.freeKeyMap[String(free.key)] = true;
    });

    /* Backward compatibility for one pre-update Halo pair already sitting in cart. */
    if (legacyPaid.length === 1 && legacyFree.length === 1) {
      result.freeByPaidKey[String(legacyPaid[0].key)] = legacyFree[0];
      result.freeKeyMap[String(legacyFree[0].key)] = true;
    }

    return result;
  }

  function itemFinalLinePrice(item) {
    if (!item) return 0;
    if (Object.prototype.hasOwnProperty.call(item, 'final_line_price')) {
      return Number(item.final_line_price || 0);
    }
    return Number(item.line_price || 0);
  }

  function itemOriginalLinePrice(item) {
    if (!item) return 0;
    if (Object.prototype.hasOwnProperty.call(item, 'original_line_price')) {
      return Number(item.original_line_price || 0);
    }
    return Number(item.line_price || itemFinalLinePrice(item) || 0);
  }

  function parseDeterministicHaloBundleId(bundleId) {
    var match = String(bundleId || '').match(/^halo-(\d+)-(\d+)$/);
    if (!match) return null;
    return {
      paidVariantId: Number(match[1]),
      straightVariantId: Number(match[2])
    };
  }

  function postHaloLineQuantity(key, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: Math.max(0, Number(quantity || 0)) })
    }).then(function (response) {
      if (!response.ok) throw new Error('Could not update Halo bundle quantity');
      return response.json();
    });
  }

  function addHaloFreeQuantity(variantId, quantity, bundleId) {
    quantity = Math.max(0, Number(quantity || 0));
    if (!variantId || quantity < 1) return Promise.resolve(false);

    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        items: [{
          id: Number(variantId),
          quantity: quantity,
          properties: {
            '_GlazyBoo_bundle': 'Straight free pair',
            '_GlazyBoo_halo_bundle_id': String(bundleId || '')
          }
        }]
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (json) {
          throw new Error(json.description || json.message || 'Could not add matching Straight Halo quantity');
        });
      }
      return response.json();
    });
  }

  function runHaloOps(ops) {
    if (!ops.length) return Promise.resolve(false);
    return ops.reduce(function (promise, op) {
      return promise.then(op);
    }, Promise.resolve()).then(function () { return true; });
  }

  /*
    Halo 1+1 quantity reconciliation.
    - Identical Wavy selections are consolidated to one paid line with quantity N.
    - The matching Straight line is kept at the exact same quantity N.
    - Orphan Straight lines are removed.
    - Only lines carrying the private _GlazyBoo_bundle property are touched.
  */
  function reconcileHaloBundles(cartInput) {
    function readCart() {
      return fetch('/cart.js', {
        headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' },
        credentials: 'same-origin'
      }).then(function (response) {
        if (!response.ok) throw new Error('Could not read cart for Halo bundle sync');
        return response.json();
      });
    }

    function normalizePaidLines(cart) {
      var paidGroups = {};
      var freeByBundleId = {};

      (cart.items || []).forEach(function (item) {
        if (isHaloBundleFreeItem(item)) {
          var freeId = haloBundleId(item);
          if (freeId) {
            freeByBundleId[freeId] = freeByBundleId[freeId] || [];
            freeByBundleId[freeId].push(item);
          }
          return;
        }

        if (!isHaloBundlePaidItem(item)) return;
        var key = String(item.variant_id);
        paidGroups[key] = paidGroups[key] || [];
        paidGroups[key].push(item);
      });

      var ops = [];

      Object.keys(paidGroups).forEach(function (variantId) {
        var group = paidGroups[variantId];
        if (group.length < 2) return;

        var totalQty = group.reduce(function (sum, item) {
          return sum + Number(item.quantity || 0);
        }, 0);

        var keeper = group.find(function (item) {
          var id = haloBundleId(item);
          return id && freeByBundleId[id] && freeByBundleId[id].length;
        }) || group[0];

        if (Number(keeper.quantity || 0) !== totalQty) {
          ops.push(function () { return postHaloLineQuantity(keeper.key, totalQty); });
        }

        group.forEach(function (item) {
          if (item.key === keeper.key) return;
          ops.push(function () { return postHaloLineQuantity(item.key, 0); });
        });
      });

      return runHaloOps(ops);
    }

    function syncFreeLines(cart) {
      var groups = {};
      var inferredStraightByPaidVariant = {};

      (cart.items || []).forEach(function (item) {
        if (!isHaloBundlePaidItem(item) && !isHaloBundleFreeItem(item)) return;
        var id = haloBundleId(item);
        if (!id) return;
        groups[id] = groups[id] || { paid: [], free: [] };
        if (isHaloBundlePaidItem(item)) groups[id].paid.push(item);
        if (isHaloBundleFreeItem(item)) groups[id].free.push(item);
      });

      Object.keys(groups).forEach(function (id) {
        var group = groups[id];
        if (!group.paid.length || !group.free.length) return;
        var paidVariantId = Number(group.paid[0].variant_id);
        var freeVariantId = Number(group.free[0].variant_id);
        if (paidVariantId && freeVariantId) inferredStraightByPaidVariant[paidVariantId] = freeVariantId;
      });

      var ops = [];

      Object.keys(groups).forEach(function (id) {
        var group = groups[id];
        var paidQty = group.paid.reduce(function (sum, item) { return sum + Number(item.quantity || 0); }, 0);
        var freeQty = group.free.reduce(function (sum, item) { return sum + Number(item.quantity || 0); }, 0);

        if (paidQty < 1) {
          group.free.forEach(function (item) {
            ops.push(function () { return postHaloLineQuantity(item.key, 0); });
          });
          return;
        }

        var targetStraightVariant = group.free.length ? Number(group.free[0].variant_id) : 0;
        if (!targetStraightVariant) {
          var deterministic = parseDeterministicHaloBundleId(id);
          if (deterministic) targetStraightVariant = deterministic.straightVariantId;
        }
        if (!targetStraightVariant && group.paid.length) {
          targetStraightVariant = Number(inferredStraightByPaidVariant[Number(group.paid[0].variant_id)] || 0);
        }

        if (!group.free.length) {
          if (targetStraightVariant) {
            ops.push(function () { return addHaloFreeQuantity(targetStraightVariant, paidQty, id); });
          }
          return;
        }

        var keeper = group.free[0];
        if (Number(keeper.quantity || 0) !== paidQty || group.free.length > 1) {
          ops.push(function () { return postHaloLineQuantity(keeper.key, paidQty); });
          group.free.slice(1).forEach(function (item) {
            ops.push(function () { return postHaloLineQuantity(item.key, 0); });
          });
        } else if (freeQty !== paidQty) {
          /* Defensive fallback for unusual Shopify split-line responses. */
          ops.push(function () { return postHaloLineQuantity(keeper.key, paidQty); });
        }
      });

      return runHaloOps(ops);
    }

    var startingCartPromise = cartInput ? Promise.resolve(cartInput) : readCart();
    var changed = false;

    return startingCartPromise
      .then(function (cart) {
        var hasHalo = (cart.items || []).some(function (item) {
          return isHaloBundlePaidItem(item) || isHaloBundleFreeItem(item);
        });
        if (!hasHalo) return null;
        return normalizePaidLines(cart).then(function (didChange) {
          changed = changed || didChange;
          return didChange ? readCart() : cart;
        });
      })
      .then(function (cart) {
        if (!cart) return false;
        return syncFreeLines(cart).then(function (didChange) {
          changed = changed || didChange;
          return changed;
        });
      });
  }

  function renderHaloBundleFreeRow(item) {
    if (!item) return '';

    var image = item.image || '';
    var finalLine = itemFinalLinePrice(item);
    var originalLine = itemOriginalLinePrice(item);
    var actuallyFree = originalLine > 0 && finalLine === 0;
    var title = item.product_title || item.title || 'Straight Halo Extension';
    var variant = item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '';
    var qty = Math.max(1, Number(item.quantity || 1));
    var priceHtml = '<div class="gbcc__halo-free-price">';

    if (originalLine > finalLine) {
      priceHtml += '<span>' + escapeHtml(formatMoney(originalLine)) + '</span>';
    }

    priceHtml += '<strong' + (actuallyFree ? ' class="is-free"' : '') + '>' +
      escapeHtml(actuallyFree ? 'FREE' : formatMoney(finalLine)) + '</strong>';
    priceHtml += '</div>';

    var html = '<div class="gbcc__halo-free" data-gbcc-halo-free-row data-key="' + escapeHtml(item.key) + '">';
    html += '<div class="gbcc__halo-free-img">' + (image ? '<img loading="lazy" decoding="async" src="' + escapeHtml(image) + '" alt="' + escapeHtml(title) + '">' : '') + '</div>';
    html += '<div class="gbcc__halo-free-main">';
    html += '<div class="gbcc__halo-free-title">' + escapeHtml(title) + '</div>';
    if (variant) html += '<div class="gbcc__halo-free-variant">' + escapeHtml(variant) + '</div>';
    html += '<div class="gbcc__halo-free-note">Included with your 1+1 bundle' + (qty > 1 ? ' · Qty ' + qty : '') + '</div>';
    html += '</div>';
    html += priceHtml;
    html += '</div>';
    return html;
  }

  function getBogoUrgencyVariant() {
    var winner = 'black_bar';

    try {
      localStorage.setItem(BOGO.storageKey, winner);
    } catch (e) {}

    return winner;
  }

  function getBogoData(cart) {
    var data = {
      paidQty: 0,
      unitPrice: 0,
      giftMap: {},
      displayItems: [],
      compareTotal: 0
    };

    var mergedMap = {};
    var mergedOrder = [];

    (cart.items || []).forEach(function (item) {
      var lineOriginal = Number(item._gbcc_compare_line_price || item.original_line_price || item.line_price || item.final_line_price || 0);
      data.compareTotal += lineOriginal;

      if (isGiftItem(item)) {
        if (item.properties && item.properties._glazyboo_bogo_slot) {
          data.giftMap[String(item.properties._glazyboo_bogo_slot)] = item;
        }
        return;
      }

      if (isEligibleBogoPaidItem(item)) {
        data.paidQty += Number(item.quantity || 0);
        if (!data.unitPrice) data.unitPrice = Number(item.original_price || item.final_price || item.price || 0);

        var mergeKey = 'gb_paid_' + String(item.variant_id);
        if (!mergedMap[mergeKey]) {
          var clone = Object.assign({}, item);
          clone.quantity = Number(item.quantity || 0);
          clone.final_line_price = Number(item.final_line_price || item.line_price || 0);
          clone.original_line_price = Number(item.original_line_price || item.line_price || item.final_line_price || 0);
          clone._gbcc_compare_line_price = Number(item._gbcc_compare_line_price || item.original_line_price || item.line_price || item.final_line_price || 0);
          clone._gbcc_compare_unit_price = Number(item._gbcc_compare_unit_price || item.original_price || item.final_price || item.price || 0);
          clone._gbcc_keys = [item.key];
          clone._gbcc_merge_variant_id = Number(item.variant_id);
          mergedMap[mergeKey] = clone;
          mergedOrder.push(mergeKey);
        } else {
          mergedMap[mergeKey].quantity += Number(item.quantity || 0);
          mergedMap[mergeKey].final_line_price += Number(item.final_line_price || item.line_price || 0);
          mergedMap[mergeKey].original_line_price += Number(item.original_line_price || item.line_price || item.final_line_price || 0);
          mergedMap[mergeKey]._gbcc_compare_line_price += Number(item._gbcc_compare_line_price || item.original_line_price || item.line_price || item.final_line_price || 0);
          mergedMap[mergeKey]._gbcc_keys.push(item.key);
        }
        return;
      }

      var normalKey = 'line_' + String(item.key);
      mergedMap[normalKey] = item;
      mergedOrder.push(normalKey);
    });

    data.displayItems = mergedOrder.map(function (key) { return mergedMap[key]; });
    return data;
  }

  function getBogoStyleByPaidVariantId(variantId) {
    variantId = Number(variantId);
    return BOGO.styles.find(function (style) {
      return Number(style.paidVariantId) === variantId;
    }) || BOGO.styles[0];
  }

  function buildPaidBogoSlotsFromCart(cart) {
    var slots = [];
    (cart.items || []).forEach(function (item) {
      if (!isEligibleBogoPaidItem(item)) return;
      var style = getBogoStyleByPaidVariantId(item.variant_id);
      var qty = Number(item.quantity || 0);
      for (var i = 0; i < qty; i++) {
        slots.push({
          freeVariantId: Number(style.freeVariantId),
          styleName: style.label
        });
      }
    });
    return slots;
  }

  function syncDefaultBogoGifts(cartInput) {
    return (cartInput && Array.isArray(cartInput.items) ? Promise.resolve(cartInput) : fetch('/cart.js', {
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); }))
      .then(function (cart) {
        var paidSlots = buildPaidBogoSlotsFromCart(cart);
        var giftsBySlot = {};
        var ops = [];

        if (!paidSlots.length) {
          (cart.items || []).forEach(function (item) {
            if (!isGiftItem(item)) return;
            ops.push(function () {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ id: item.key, quantity: 0 })
              }).then(function (r) { return r.json(); });
            });
          });

          if (!ops.length) return false;

          return ops.reduce(function (promise, op) {
            return promise.then(op);
          }, Promise.resolve()).then(function () { return true; });
        }

        (cart.items || []).forEach(function (item) {
          if (!isGiftItem(item)) return;
          var slot = item.properties && item.properties._glazyboo_bogo_slot ? String(item.properties._glazyboo_bogo_slot) : '';
          if (!slot || giftsBySlot[slot]) {
            ops.push(function () {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ id: item.key, quantity: 0 })
              }).then(function (r) { return r.json(); });
            });
            return;
          }
          giftsBySlot[slot] = item;
        });

        paidSlots.forEach(function (slotData, index) {
          var slot = String(index + 1);
          var existing = giftsBySlot[slot];

          // Important:
          // If a gift already exists for this slot, keep the customer's selected style.
          // Only default to the paid style when the slot has no gift yet.
          if (existing) {
            if (Number(existing.quantity || 0) !== 1) {
              ops.push(function () {
                return fetch('/cart/change.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                  credentials: 'same-origin',
                  body: JSON.stringify({ id: existing.key, quantity: 1 })
                }).then(function (r) { return r.json(); });
              });
            }
            return;
          }

          ops.push(function () {
            return addBogoGift(slotData.freeVariantId, slot, slotData.styleName);
          });
        });

        Object.keys(giftsBySlot).forEach(function (slot) {
          if (Number(slot) > paidSlots.length) {
            var extra = giftsBySlot[slot];
            ops.push(function () {
              return fetch('/cart/change.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                credentials: 'same-origin',
                body: JSON.stringify({ id: extra.key, quantity: 0 })
              }).then(function (r) { return r.json(); });
            });
          }
        });

        if (!ops.length) return false;

        return ops.reduce(function (promise, op) {
          return promise.then(op);
        }, Promise.resolve()).then(function () { return true; });
      });
  }

  function renderBogoSlots(data) {
    if (!data.paidQty) return '';
    var moneyFormat = (window.Shopify && Shopify.money_format) || ((window.theme && theme.money_format) || '${{amount}}');
    var html = '';
    html += '<div class="gbcc__bogo-wrap" data-glazyboo-bogo-root data-product-handle="glazylash-reusable-adhesive-eyelashes" data-free-product-handle="glazylash-reusable-adhesive-eyelashes-free" data-eligible-variants="43756305907966,43756305973502,43756305940734" data-free-variants="54756149723462,54756149756230,54756149788998" data-money-format="' + escapeHtml(moneyFormat) + '" data-paid-qty="' + data.paidQty + '">';
    html += '<div class="glazyboo-bogo-slots">';
    for (var slot = 1; slot <= data.paidQty; slot++) {
      var giftItem = data.giftMap[String(slot)] || null;
      var defaultSlotStyle = buildPaidBogoSlotsFromCart(state.cart || { items: [] })[slot - 1] || null;
      var selectedVariantId = giftItem ? Number(giftItem.variant_id) : (defaultSlotStyle ? Number(defaultSlotStyle.freeVariantId) : BOGO.styles[0].freeVariantId);
      html += '<div class="glazyboo-bogo-slot" data-glazyboo-bogo-slot="' + slot + '">';
      html += '<div class="glazyboo-bogo-slot__top"><div><h3 class="glazyboo-bogo-slot__title">Free GlazyLash Pair #' + slot + '</h3><p class="glazyboo-bogo-slot__text">Choose your free style</p></div><div class="glazyboo-bogo-slot__aside"><div class="glazyboo-bogo-slot__status" data-glazyboo-bogo-status>' + (giftItem ? 'Free pair added' : 'Free pair added') + '</div><div class="glazyboo-bogo-slot__price-mobile"><span class="glazyboo-bogo-slot__was-mobile">' + escapeHtml(formatMoney(data.unitPrice)) + '</span><strong class="glazyboo-bogo-slot__free-mobile">FREE</strong></div></div></div>';
      html += '<div class="glazyboo-bogo-style-grid" role="radiogroup" aria-label="Choose free GlazyLash style #' + slot + '">';
      BOGO.styles.forEach(function(style){
        var isSelected = Number(selectedVariantId) === Number(style.freeVariantId);
        html += '<button type="button" class="glazyboo-bogo-style' + (isSelected ? ' is-selected' : '') + '" data-glazyboo-bogo-select data-slot="' + slot + '" data-variant-id="' + style.freeVariantId + '" data-style-name="' + escapeHtml(style.label) + '"><img loading="lazy" src="' + escapeHtml(style.image) + '" alt="' + escapeHtml(style.label + ' GlazyLash') + '"><span>' + escapeHtml(style.label) + '</span></button>';
      });
      html += '</div></div>';
    }
    html += '</div></div>';
    return html;
  }

  /*
    Shared 5-minute urgency clock for both Halo 1+1 and lash BOGO.
    Uses the same sessionStorage key as the native cart page so moving between
    overlay and /cart never creates two timers or resets the countdown.
  */
  function getTimerState() {
    var now = Date.now();
    var duration = 5 * 60 * 1000;
    var storageKey = 'glazyboo_bogo_reserve_timer_ends_at_v1';
    var endsAt = 0;

    try {
      endsAt = parseInt(sessionStorage.getItem(storageKey), 10) || 0;
      if (!endsAt || endsAt <= now) {
        endsAt = now + duration;
        sessionStorage.setItem(storageKey, String(endsAt));
      }
    } catch (e) {
      endsAt = Number(state.timerEndsAt || 0);
      if (!endsAt || endsAt <= now) endsAt = now + duration;
    }

    state.timerEndsAt = endsAt;

    var remainingMs = Math.max(0, endsAt - now);
    var remainingSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
    var mins = Math.floor(remainingSeconds / 60);
    var secs = remainingSeconds % 60;

    return {
      expired: false,
      text: String(mins).padStart(2, '0') + ':' + String(secs).padStart(2, '0')
    };
  }

  function getTimerValue() {
    return getTimerState().text;
  }

  function ensureCartShell() {
    var root = document.getElementById('glazyboo-custom-cart');
    if (root) return root;

    root = document.createElement('div');
    root.id = 'glazyboo-custom-cart';
    root.className = 'gbcc';
    root.setAttribute('aria-hidden', 'true');
    root.innerHTML =
      '<div class="gbcc__backdrop" data-gbcc-close></div>' +
      '<aside class="gbcc__panel" role="dialog" aria-modal="true" aria-label="Your cart">' +
        '<div class="gbcc__inner" data-gbcc-inner></div>' +
      '</aside>';
    document.body.appendChild(root);


    if (!root.__gbccBogoCaptureInstalled) {
      root.__gbccBogoCaptureInstalled = true;
      root.addEventListener('click', function (e) {
        var styleButton = e.target.closest('[data-glazyboo-bogo-select]');
        if (!styleButton || !root.contains(styleButton)) return;

        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        changeBogoSlot(
          styleButton.getAttribute('data-slot'),
          styleButton.getAttribute('data-variant-id'),
          styleButton.getAttribute('data-style-name') || ''
        );
        return false;
      }, true);
    }

    root.addEventListener('click', function (e) {
      var styleButton = e.target.closest('[data-glazyboo-bogo-select]');
      if (styleButton && root.contains(styleButton)) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        changeBogoSlot(
          styleButton.getAttribute('data-slot'),
          styleButton.getAttribute('data-variant-id'),
          styleButton.getAttribute('data-style-name') || ''
        );
        return false;
      }

      var close = e.target.closest('[data-gbcc-close]');
      if (close) {
        e.preventDefault();
        closeCart();
        return;
      }

      var minus = e.target.closest('[data-gbcc-minus]');
      var plus = e.target.closest('[data-gbcc-plus]');
      var remove = e.target.closest('[data-gbcc-remove]');
      var checkout = e.target.closest('[data-gbcc-checkout]');

      if (checkout) {
        setCartAttributes().finally(function () { window.location.href = '/checkout'; });
        return;
      }

      if (minus || plus || remove) {
        e.preventDefault();
        var btn = minus || plus || remove;
        var key = btn.getAttribute('data-key');
        var variantId = btn.getAttribute('data-variant-id');
        var current = Number(btn.getAttribute('data-qty') || '0');

        if (variantId && (plus || minus)) {
          if (plus) {
            addVariantQuantity(Number(variantId), 1);
          } else {
            setMergedVariantQuantity(Number(variantId), Math.max(0, current - 1));
          }
          return;
        }

        var qty = remove ? 0 : (plus ? current + 1 : Math.max(0, current - 1));
        changeLine(key, qty);
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && state.isOpen) closeCart();
    });

    return root;
  }

  function renderCart(cart) {
    clearOverlayUpdating();
    state.cart = cart || state.cart || { items: [], item_count: 0, total_price: 0 };
    var root = ensureCartShell();
    var inner = root.querySelector('[data-gbcc-inner]');
    var bogoData = getBogoData(state.cart);
    var haloData = getHaloBundleData(state.cart);
    var urgencyVariant = getBogoUrgencyVariant();
    var hasReservedDeal = Number(bogoData.paidQty || 0) > 0 || Number(haloData.paidQty || 0) > 0;
    var reservedDealSource = Number(bogoData.paidQty || 0) > 0 && Number(haloData.paidQty || 0) > 0
      ? 'lashes-and-halo'
      : (Number(haloData.paidQty || 0) > 0 ? 'halo' : 'lashes');
    var items = (bogoData.displayItems || []).filter(function (item) {
      return !haloData.freeKeyMap[String(item.key)];
    });
    var html = '';

    html += '<div class="gbcc__titlebar' + (hasReservedDeal ? '' : ' gbcc__titlebar--no-urgency') + '">';
    html += '<h2 class="gbcc__title">Your cart</h2>';
    html += '<button class="gbcc__close gbcc__close--title" type="button" aria-label="Close cart" data-gbcc-close>×</button>';
    html += '</div>';

    if (!hasReservedDeal) {
      html += '<div class="gbcc__header-divider" aria-hidden="true"></div>';
    }

    /*
      One shared urgency block for Halo and/or lash BOGO.
      If both promotions are in the cart, this still renders exactly once.
    */
    if (hasReservedDeal) {
      html += '<div class="glazyboo-bogo-urgency gbcc__urgency" data-glazyboo-bogo-urgency data-glazyboo-reserved-deal-urgency data-glazyboo-reserved-deal-source="' + reservedDealSource + '" data-glazyboo-ab-variant="' + urgencyVariant + '">';
      html += '<div class="glazyboo-bogo-urgency__demand gbcc__demand">🔥 Your BOGO deal is in high demand. We\'ve reserved your free pair.</div>';
      var timerState = getTimerState();
      html += '<div class="glazyboo-bogo-urgency__timer gbcc__timerbox"><span data-gbcc-timer-wrap>⏱️ Your order is reserved for <strong data-gbcc-timer>' + timerState.text + '</strong></span></div>';
      html += '</div>';
    }

    if (!items.length) {
      html += '<div class="gbcc__empty">';
      html += '<h3>Your cart is empty</h3>';
      html += '<p>Add your GlazyBoo favorites and your cart will appear here instantly.</p>';
      html += '<button type="button" class="gbcc__secondary" data-gbcc-close>Continue shopping</button>';
      html += '</div>';
    } else {
      html += '<div class="gbcc__items">';
      var bogoRenderedInline = false;
      items.forEach(function (item) {
        var image = item.image || '';
        var linePrice = Number(item.final_line_price || item.line_price || 0);
        var comparePrice = Number(item._gbcc_compare_line_price || item.original_line_price || linePrice || 0);
        html += '<div class="gbcc__item" data-key="' + escapeHtml(item.key) + '">';
        html += '<div class="gbcc__item-img">' + (image ? '<img loading="lazy" decoding="async" src="' + escapeHtml(image) + '" alt="' + escapeHtml(item.product_title) + '">' : '') + '</div>';
        html += '<div class="gbcc__item-main">';
        html += '<div class="gbcc__item-head"><div class="gbcc__item-title">' + escapeHtml(item.product_title || item.title) + '</div><div class="gbcc__item-price"><strong>' + escapeHtml(formatMoney(linePrice)) + '</strong>' + (comparePrice > linePrice ? '<span>' + escapeHtml(formatMoney(comparePrice)) + '</span>' : '') + '</div></div>';
        if (item.variant_title && item.variant_title !== 'Default Title') html += '<div class="gbcc__variant">Style: ' + escapeHtml(item.variant_title) + '</div>';
        html += '<div class="gbcc__qty">';
        html += '<button type="button" data-gbcc-minus data-key="' + escapeHtml(item.key) + '" data-qty="' + item.quantity + '"' + (item._gbcc_merge_variant_id ? ' data-variant-id="' + item._gbcc_merge_variant_id + '"' : '') + '>−</button>';
        html += '<span>' + item.quantity + '</span>';
        html += '<button type="button" data-gbcc-plus data-key="' + escapeHtml(item.key) + '" data-qty="' + item.quantity + '"' + (item._gbcc_merge_variant_id ? ' data-variant-id="' + item._gbcc_merge_variant_id + '"' : '') + '>+</button>';
        html += '</div>';
        html += '</div>';
        html += '</div>';

        var haloFreeItem = haloData.freeByPaidKey[String(item.key)] || null;
        if (haloFreeItem) {
          html += renderHaloBundleFreeRow(haloFreeItem);
        }

        if (!bogoRenderedInline && bogoData.paidQty > 0 && isEligibleBogoPaidItem(item)) {
          html += renderBogoSlots(bogoData);
          bogoRenderedInline = true;
        }
      });

      if (!bogoRenderedInline && bogoData.paidQty > 0) {
        html += renderBogoSlots(bogoData);
      }

      html += '</div>';


    }

    inner.innerHTML = html;
    updateCartCount(state.cart.item_count || 0);
    tickTimer();
    // Do not dispatch theme:cartchanged from the custom overlay.
    // Symmetry listens to that event and performs a native cart/header section refresh.
    // In this custom cart mode that can trigger a visible page reload after ATC.
    try {
      document.dispatchEvent(new CustomEvent('glazyboo:custom-cart-rendered', {
        bubbles: true,
        detail: { source: 'glazyboo-custom-cart', cart: state.cart }
      }));
    } catch (e) {}
    return root;
  }

  function renderFooter() {
    var root = ensureCartShell();
    var panel = root.querySelector('.gbcc__panel');
    var old = root.querySelector('.gbcc__footer');
    if (old) old.remove();

    var bogoData = getBogoData(state.cart || { items: [] });
    if (!state.cart || !state.cart.items || !bogoData.displayItems.length) return;

    var itemCount = Number(state.cart.item_count || 0);
    var itemLabel = itemCount === 1 ? '1 item' : itemCount + ' items';
    var dynamicSource = document.getElementById('gbcc-dynamic-checkout-source');
    var dynamicHtml = dynamicSource ? dynamicSource.innerHTML : '';
    var compareTotal = Number(bogoData.compareTotal || state.cart.total_price || 0);
    var currentTotal = Number(state.cart.total_price || 0);
    var priceHtml = '<span class="gbcc__footer-price">';
    priceHtml += '<strong>' + escapeHtml(formatMoney(currentTotal)) + '</strong>';
    if (compareTotal > currentTotal) {
      priceHtml += '<s>' + escapeHtml(formatMoney(compareTotal)) + '</s>';
    }
    priceHtml += '</span>';

    var footer = document.createElement('div');
    footer.className = 'gbcc__footer';
    footer.innerHTML =
      '<div class="gbcc__footer-total"><span>Grand Total <em>(' + escapeHtml(itemLabel) + ')</em></span>' + priceHtml + '</div>' +
      '<button type="button" class="button button--large gbcc__checkout" data-gbcc-checkout>Proceed to Checkout ➔</button>' +
      '<div class="gbcc__dynamic-checkout" data-gbcc-dynamic-checkout>' + dynamicHtml + '</div>';
    panel.appendChild(footer);
  }

  function tickTimer() {
    var root = document.getElementById('glazyboo-custom-cart');
    if (!root) return;

    var wraps = root.querySelectorAll('[data-gbcc-timer-wrap]');
    if (!wraps.length) return;

    var timerState = getTimerState();

    wraps.forEach(function (wrap) {
      var box = wrap.closest('.gbcc__timerbox');
      if (box) box.classList.remove('is-expired');
      wrap.innerHTML = '⏱️ Your order is reserved for <strong data-gbcc-timer>' + timerState.text + '</strong>';
    });

    root.querySelectorAll('[data-gbcc-timer]').forEach(function (timer) {
      timer.textContent = timerState.text;
    });
  }
  setInterval(tickTimer, 1000);

  function openCart() {
    if (getVariant() === 'cart_page') {
      goToCartPage(false);
      return;
    }
    if (!isCustomMode()) {
      goToCartPage(false);
      return;
    }
    var root = ensureCartShell();
    var wasOpen = state.isOpen;

    if (!wasOpen) {
      try {
        history.pushState({ glazybooCartOverlayOpen: true }, '', window.location.href);
        state.historyEntryActive = true;
      } catch (e) {
        state.historyEntryActive = false;
      }
    }

    state.isOpen = true;
    state.lastFocused = document.activeElement;
    applyRootClasses();
    root.classList.remove('is-closing');
    // Force a frame so the browser can see the closed transform before opening.
    root.classList.add('is-opening');
    root.setAttribute('aria-hidden', 'false');
    requestAnimationFrame(function () {
      root.classList.add('is-open');
      root.classList.remove('is-opening');
    });
    document.documentElement.classList.add('gbcc-lock');
    document.body.classList.add('gbcc-lock');
    renderFooter();
  }

  function closeCart(options) {
    options = options || {};
    var fromPopState = !!options.fromPopState;
    var root = ensureCartShell();

    try {
      if (root.contains(document.activeElement) && document.activeElement.blur) {
        document.activeElement.blur();
      }
    } catch (e) {}

    state.isOpen = false;
    root.classList.remove('is-open', 'is-opening');
    root.classList.add('is-closing');
    root.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('gbcc-lock');
    document.body.classList.remove('gbcc-lock');
    applyRootClasses();

    window.setTimeout(function () {
      if (!state.isOpen) root.classList.remove('is-closing');
    }, 380);

    try {
      if (state.lastFocused && state.lastFocused.focus) state.lastFocused.focus();
    } catch (e) {}

    if (fromPopState) {
      state.historyEntryActive = false;
      return;
    }

    if (state.historyEntryActive) {
      state.historyEntryActive = false;
      try {
        history.back();
      } catch (e) {}
    }
  }

  window.addEventListener('popstate', function () {
    if (!state.isOpen) return;
    state.historyEntryActive = false;
    closeCart({ fromPopState: true });
  });

  function fetchCart() {
    // Prevent request storms and Shopify 429s.
    // If multiple events ask for the cart at once, share the same request.
    if (state.pendingFetch) return state.pendingFetch;

    var now = Date.now();
    if (state.lastCartJson && now - state.lastFetchAt < 350) {
      clearOverlayUpdating();
      renderCart(state.lastCartJson);
      return Promise.resolve(state.lastCartJson);
    }

    state.pendingFetch = fetch('/cart.js', {
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' },
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) {
          if (state.lastCartJson) return state.lastCartJson;
          throw new Error('cart.js failed: ' + r.status);
        }
        return r.json();
      })
      .then(function (cart) {
        state.lastFetchAt = Date.now();
        state.lastCartJson = cart;
        renderCart(cart);
        if (state.isOpen || getVariant() === 'overlay_cart') renderFooter();
        hydrateCompareAtPrices(cart).then(function (hydratedCart) {
          // Never overwrite a newer cart or interrupt a quantity/free-style update.
          if (state.lastCartJson !== cart || state.busy) return;
          renderCart(hydratedCart);
        }).catch(function () {});
        return cart;
      })
      .finally(function () { state.pendingFetch = null; });

    return state.pendingFetch;
  }

  function setCartAttributes() {
    var variant = getVariant();
    try {
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({
          attributes: {
            glazyboo_cart_experience_variant: variant,
            glazyboo_cart_experience_test: originalMode() === 'overlay_ab' ? 'sitewide_overlay_vs_cart_page' : 'manual_' + originalMode(),
            glazyboo_cart_experience_version: VERSION
          }
        })
      }).then(function (response) {
        if (!response.ok) return null;
        return response.json();
      }).catch(function () { return null; });
    } catch (e) {
      return Promise.resolve();
    }
  }

  function afterExternalAdd() {
    state.lastCartJson = null;
    state.lastFetchAt = 0;
    applyRootClasses();

    /*
      The Halo request has already added both lines in one Shopify Ajax call.
      Keep this hand-off light so it does not create an unnecessary cart-request
      burst: write experiment attribution once, then use the existing mode router.
    */
    return setCartAttributes()
      .then(function (cart) { return reconcileHaloBundles(cart); })
      .catch(function (err) {
        console.warn('[GlazyBoo cart] Halo quantity sync warning', err);
        return false;
      })
      .then(function () {
        if (getVariant() === 'cart_page') {
          goToCartPage(true);
          return null;
        }

        if (!isCustomMode()) {
          goToCartPage(false);
          return null;
        }

        state.lastCartJson = null;
        state.lastFetchAt = 0;
        return fetchCart().then(function () { openCart(); });
      })
      .catch(function (err) {
        console.warn('[GlazyBoo cart] Halo bundle hand-off failed, using cart page fallback', err);
        goToCartPage(false);
        return null;
      });
  }

  function addToCart(form, submitter) {
    if (!isCustomMode()) return false;

    var validVariantId = getValidVariantIdFromForm(form);
    if (!validVariantId) {
      console.warn('[GlazyBoo cart] ignored add-to-cart submit without a valid variant id', form);
      return false;
    }

    if (state.busy) return true;
    state.busy = true;
    applyRootClasses();

    var buttons = [];
    if (submitter) buttons.push(submitter);
    try {
      buttons = buttons.concat(Array.prototype.slice.call(form.querySelectorAll(REAL_ATC_BUTTON_SELECTOR)));
      buttons = buttons.filter(function (button, index, list) {
        return button && list.indexOf(button) === index && !shouldIgnoreAddToCartTrigger(button);
      });
    } catch (e) {}
    buttons.forEach(function (b) { try { b.disabled = true; b.classList.add('gbcc-loading'); } catch (e) {} });

    var fd = new FormData(form);
    fd.set('id', validVariantId);

    return fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin'
    })
      .then(function (r) {
        if (!r.ok) {
          return r.text().then(function (txt) {
            var err;
            try { err = JSON.parse(txt); } catch (e) {
              err = { status: r.status, message: 'Cart Error', description: txt.slice(0, 120) };
            }
            throw err;
          });
        }
        return r.json();
      })
      .then(function () { return setCartAttributes(); })
      .then(function (cart) { return syncDefaultBogoGifts(cart).catch(function () {}); })
      .then(function () {
        if (getVariant() === 'cart_page') {
          goToCartPage(true);
          return null;
        }
        state.lastCartJson = null; state.lastFetchAt = 0; return fetchCart().then(function () { openCart(); });
      })
      .catch(function (err) {
        console.warn('[GlazyBoo cart] add failed', err);
        clearOverlayUpdating();

        // Important:
        // Never call native form.submit() here. If Shopify/app returns 422/429/HTML,
        // native submit causes the exact page refresh/cart-close bug.
        // Keep the customer on the current page and, if possible, refresh/open the overlay.
        state.lastCartJson = null;
        state.lastFetchAt = 0;

        if (getVariant() === 'cart_page') {
          return;
        }

        return fetchCart()
          .then(function () { openCart(); })
          .catch(function () {
            // Swallow failed recovery, do not redirect/refresh.
          });
      })
      .finally(function () {
        state.busy = false;
        buttons.forEach(function (b) { try { b.disabled = false; b.classList.remove('gbcc-loading'); } catch (e) {} });
      });
  }

  function clearOverlayUpdating() {
    if (state.updatingFailsafeTimer) {
      clearTimeout(state.updatingFailsafeTimer);
      state.updatingFailsafeTimer = null;
    }

    var root = document.getElementById('glazyboo-custom-cart');
    if (!root) return;

    root.classList.remove('gbcc-is-updating');
    root.querySelectorAll('.gbcc-is-updating-target').forEach(function (node) {
      node.classList.remove('gbcc-is-updating-target');
    });
    root.querySelectorAll('[data-gbcc-updating-label]').forEach(function (node) {
      node.remove();
    });

    var panel = root.querySelector('.gbcc__panel');
    if (panel) panel.setAttribute('aria-busy', 'false');
  }

  function setOverlayUpdating(active, target) {
    var root = ensureCartShell();
    if (!root) return;

    if (!active) {
      clearOverlayUpdating();
      return;
    }

    clearOverlayUpdating();
    root.classList.add('gbcc-is-updating');

    var panel = root.querySelector('.gbcc__panel');
    if (panel) panel.setAttribute('aria-busy', 'true');

    var targetNode = target && target.nodeType ? target : null;
    if (!targetNode && target && typeof target === 'string') {
      targetNode = root.querySelector(target);
    }
    if (!targetNode) {
      targetNode = root.querySelector('.gbcc__items') || root.querySelector('.gbcc__inner');
    }

    targetNode.classList.add('gbcc-is-updating-target');

    if (state.updatingFailsafeTimer) {
      clearTimeout(state.updatingFailsafeTimer);
    }
    state.updatingFailsafeTimer = setTimeout(function () {
      clearOverlayUpdating();
    }, 6500);

    var label = document.createElement('div');
    label.className = 'gbcc__updating';
    label.setAttribute('data-gbcc-updating-label', '');
    label.setAttribute('aria-live', 'polite');
    label.innerHTML = '<span class="gbcc__spinner" aria-hidden="true"></span><strong>Updating your cart...</strong>';
    targetNode.appendChild(label);
  }

  function addBogoGift(freeVariantId, slot, styleName) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({
        id: Number(freeVariantId),
        quantity: 1,
        properties: {
          _glazyboo_bogo_gift: 'true',
          _glazyboo_bogo_slot: String(slot),
          _glazyboo_bogo_parent: 'glazylash-reusable-adhesive-eyelashes',
          _glazyboo_bogo_style: styleName || ''
        }
      })
    }).then(function (response) {
      if (!response.ok) {
        return response.json().catch(function () { return {}; }).then(function (json) {
          throw new Error(json.description || json.message || 'Could not add free pair');
        });
      }
      return response.json();
    });
  }

  function changeBogoSlot(slot, freeVariantId, styleName) {
    if (state.busy) return;
    state.busy = true;

    state.lastCartJson = null;
    state.lastFetchAt = 0;

    var root = ensureCartShell();
    var slotContainer = root.querySelector('[data-glazyboo-bogo-slot="' + String(slot) + '"]');
    setOverlayUpdating(true, slotContainer || '[data-glazyboo-bogo-root]');

    if (slotContainer) {
      slotContainer.querySelectorAll('[data-glazyboo-bogo-select]').forEach(function (button) {
        button.classList.toggle('is-selected', Number(button.getAttribute('data-variant-id')) === Number(freeVariantId));
      });

      var status = slotContainer.querySelector('[data-glazyboo-bogo-status]');
      if (status) status.textContent = 'Updating free pair...';
    }

    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var existing = null;
        (cart.items || []).forEach(function (item) {
          if (
            isGiftItem(item) &&
            item.properties &&
            String(item.properties._glazyboo_bogo_slot) === String(slot)
          ) {
            existing = item;
          }
        });

        if (existing && Number(existing.variant_id) === Number(freeVariantId)) {
          return false;
        }

        var chain = Promise.resolve();

        if (existing) {
          chain = chain.then(function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: existing.key, quantity: 0 })
            }).then(function (r) { return r.json(); });
          });
        }

        chain = chain.then(function () {
          return addBogoGift(freeVariantId, slot, styleName);
        });

        return chain.then(function () { return true; });
      })
      .then(function () {
        state.lastCartJson = null;
        state.lastFetchAt = 0;
        return fetchCart();
      })
      .then(function () {
        renderFooter();
      })
      .catch(function (err) {
        console.warn('[GlazyBoo custom overlay BOGO]', err);
        if (slotContainer) {
          var status = slotContainer.querySelector('[data-glazyboo-bogo-status]');
          if (status) status.textContent = 'Please try again';
        }
      })
      .finally(function () {
        state.busy = false;
        setOverlayUpdating(false);
      });
  }

  function addVariantQuantity(variantId, quantity) {
    if (state.busy) return;
    state.busy = true;
    var target = ensureCartShell().querySelector('[data-variant-id="' + Number(variantId) + '"]');
    setOverlayUpdating(true, target ? target.closest('.gbcc__item') : '.gbcc__items');
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: Number(variantId), quantity: Math.max(1, Number(quantity || 1)) })
    })
      .then(function (r) { return r.json(); })
      .then(function () {
        return syncDefaultBogoGifts().catch(function () {});
      })
      .then(function () {
        return reconcileHaloBundles().catch(function () {});
      })
      .then(function () {
        state.lastCartJson = null;
        state.lastFetchAt = 0;
        return fetchCart();
      })
      .then(function () { renderFooter(); })
      .finally(function () { state.busy = false; setOverlayUpdating(false); });
  }

  function setMergedVariantQuantity(variantId, targetQty) {
    if (state.busy) return;
    state.busy = true;
    var target = ensureCartShell().querySelector('[data-variant-id="' + Number(variantId) + '"]');
    setOverlayUpdating(true, target ? target.closest('.gbcc__item') : '.gbcc__items');
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json', 'Cache-Control': 'no-cache' },
      credentials: 'same-origin'
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var matching = (cart.items || []).filter(function (item) {
          return Number(item.variant_id) === Number(variantId) && !isGiftItem(item);
        });
        var remaining = Math.max(0, Number(targetQty || 0));
        var ops = matching.map(function (item, index) {
          var qty = index === 0 ? remaining : 0;
          return function () {
            return fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: item.key, quantity: qty })
            }).then(function (r) { return r.json(); });
          };
        });
        return ops.reduce(function (promise, op) {
          return promise.then(op);
        }, Promise.resolve());
      })
      .then(function () {
        return syncDefaultBogoGifts().catch(function () {});
      })
      .then(function () {
        return reconcileHaloBundles().catch(function () {});
      })
      .then(function () {
        state.lastCartJson = null;
        state.lastFetchAt = 0;
        return fetchCart();
      })
      .then(function () { renderFooter(); })
      .finally(function () { state.busy = false; setOverlayUpdating(false); });
  }

  function changeLine(key, quantity) {
    if (state.busy) return;
    state.busy = true;
    setOverlayUpdating(true, '[data-key="' + String(key).replace(/"/g, '\\\"') + '"]');
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        return syncDefaultBogoGifts().catch(function () { return false; })
          .then(function () { return reconcileHaloBundles(cart).catch(function () { return false; }); })
          .then(function () {
            state.lastCartJson = null;
            state.lastFetchAt = 0;
            return fetchCart();
          });
      })
      .then(function () { renderFooter(); })
      .finally(function () { state.busy = false; setOverlayUpdating(false); });
  }

  function updateCartCount(count) {
    var selectors = [
      '.cart-link__count', '.cart-count', '[data-cart-count]', '.header-cart-count', '.cart-item-count', '.cart-link .count'
    ];
    selectors.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        el.textContent = count;
        el.classList.toggle('hidden', count < 1);
        el.classList.toggle('visually-hidden', count < 1 && el.classList.contains('visually-hidden'));
      });
    });
  }

  function isCartAddForm(form) {
    if (!form || !form.getAttribute) return false;
    var action = form.getAttribute('action') || '';

    // Only intercept real Shopify add-to-cart forms.
    // Do NOT treat every form with [name="id"] as cart add, because apps/pixels can have
    // unrelated id fields and this was causing invalid /cart/add.js calls + refreshes.
    return action.indexOf('/cart/add') !== -1;
  }

  function getValidVariantIdFromForm(form) {
    if (!form) return null;

    var fd;
    try {
      fd = new FormData(form);
    } catch (e) {
      return null;
    }

    var id = fd.get('id');

    if (!id) {
      var idInput = form.querySelector('[name="id"]');
      if (idInput && idInput.value) id = idInput.value;
    }

    id = String(id || '').trim();

    if (!/^\d+$/.test(id)) return null;

    return id;
  }


  function isKachingBundleForm(form) {
    if (!form) return false;

    try {
      if (form.querySelector('[name="properties[__kaching_bundles]"]')) {
        return true;
      }
    } catch (e) {}

    try {
      var fd = new FormData(form);
      return fd.has('properties[__kaching_bundles]');
    } catch (e) {
      return false;
    }
  }

  function installInterceptors() {
    if (!isCustomMode()) return;
    if (shouldLeaveNativeCartPageAlone()) return;

    // We fully control Add to Cart in overlay/cart-page test mode.
    // Keep native theme/app handlers from deciding a different behavior first.
    window.theme = window.theme || {};
    theme.settings = theme.settings || {};
    theme.settings.cart_type = getVariant() === 'cart_page' ? 'page' : 'drawer';
    theme.settings.after_add_to_cart = getVariant() === 'cart_page' ? 'page' : 'drawer';

    // Hard stop native form POST/page refresh.
    document.addEventListener('submit', function (e) {
      var form = e.target;
      if (!isCartAddForm(form)) return;

      var submitter = getSubmitterFromEvent(e);
      if (submitter && (isDynamicCheckoutTrigger(submitter) || shouldIgnoreAddToCartTrigger(submitter))) {
        return;
      }

      if (!getValidVariantIdFromForm(form)) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        console.warn('[GlazyBoo cart] blocked invalid add-to-cart submit', form);
        return false;
      }
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      addToCart(form, submitter);
      return false;
    }, true);

    // Catch Add to Cart buttons before app/theme click handlers can redirect.
    document.addEventListener('click', function (e) {
      var checkout = e.target.closest('a[href*="/checkout"], button[name="checkout"], [name="checkout"], [data-gbcc-checkout], ' + DYNAMIC_CHECKOUT_SELECTOR);
      if (checkout) return;

      var cartLink = e.target.closest('a[href]');
      if (cartLink) {
        var href = cartLink.getAttribute('href') || '';
        if ((href === '/cart' || href.indexOf('/cart') === 0 || href.indexOf(window.location.origin + '/cart') === 0) && href.indexOf('/cart/add') === -1) {
          if (getVariant() === 'cart_page') return;
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          fetchCart().then(openCart);
          return false;
        }
      }

      var btn = e.target.closest(ADD_TO_CART_BUTTON_SELECTOR);
      if (!btn) return;
      if (shouldIgnoreAddToCartTrigger(btn)) return;
      var form = btn.form || btn.closest('form');
      if (!isCartAddForm(form)) return;

      // Kaching Bundles attaches its own capture-phase click handler directly
      // to the product Add to Cart button. It must run first so mixed bundle
      // selections can add the extra variants before the main form submits.
      //
      // We still intercept the following submit event, so the GlazyBoo
      // overlay/cart-page A/B behavior remains in control after Kaching has
      // prepared and added the complete bundle.
      if (isKachingBundleForm(form)) {
        return;
      }

      if (!getValidVariantIdFromForm(form)) {
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();
        console.warn('[GlazyBoo cart] blocked invalid add-to-cart click', form);
        return false;
      }
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
      addToCart(form, btn);
      return false;
    }, true);

    // Catch scripts that call form.requestSubmit()/form.submit() directly.
    var nativeSubmit = HTMLFormElement.prototype.submit;
    var nativeRequestSubmit = HTMLFormElement.prototype.requestSubmit;

    if (!HTMLFormElement.prototype.__gbccSubmitPatched) {
      HTMLFormElement.prototype.__gbccSubmitPatched = true;
      HTMLFormElement.prototype.submit = function () {
        if (isCustomMode() && isCartAddForm(this)) {
          var activeSubmitter = getSubmitterFromEvent({ submitter: document.activeElement });
          if (activeSubmitter && (isDynamicCheckoutTrigger(activeSubmitter) || shouldIgnoreAddToCartTrigger(activeSubmitter))) {
            return nativeSubmit.apply(this, arguments);
          }
          if (!getValidVariantIdFromForm(this)) {
            console.warn('[GlazyBoo cart] blocked native submit without valid variant id', this);
            return;
          }
          addToCart(this, null);
          return;
        }
        return nativeSubmit.apply(this, arguments);
      };
      if (nativeRequestSubmit) {
        HTMLFormElement.prototype.requestSubmit = function (submitter) {
          if (isCustomMode() && isCartAddForm(this)) {
            if (submitter && (isDynamicCheckoutTrigger(submitter) || shouldIgnoreAddToCartTrigger(submitter))) {
              return nativeRequestSubmit.apply(this, arguments);
            }
            if (!getValidVariantIdFromForm(this)) {
              console.warn('[GlazyBoo cart] blocked native requestSubmit without valid variant id', this);
              return;
            }
            addToCart(this, submitter || null);
            return;
          }
          return nativeRequestSubmit.apply(this, arguments);
        };
      }
    }
  }

  function reset() {
    try { localStorage.removeItem(KEY); } catch (e) {}
    LEGACY_KEYS.forEach(function (k) { try { localStorage.removeItem(k); } catch(e) {} });
    location.reload();
  }

  window.GlazyBooCartExperience = window.GlazyBooCartExperience || {};
  Object.assign(window.GlazyBooCartExperience, {
    version: VERSION,
    key: KEY,
    getVariant: getVariant,
    getStoredVariant: getStoredVariant,
    forceOverlay: function () { setStoredVariant('overlay_cart'); location.reload(); },
    forcePage: function () { setStoredVariant('cart_page'); location.reload(); },
    forceCartPage: function () { setStoredVariant('cart_page'); location.reload(); },
    forceNativeDrawer: function () { try { localStorage.removeItem(KEY); } catch(e) {} location.reload(); },
    reset: reset,
    openCart: function () { fetchCart().then(openCart); },
    closeCart: closeCart,
    refresh: fetchCart,
    addForm: addToCart,
    afterExternalAdd: afterExternalAdd
  });

  // Important: on the real /cart page, leave Shopify/Symmetry quantity,
  // remove and update behavior fully native. We only write the experiment
  // attribution once so direct/pre-existing cart visits are still attributed.
  if (shouldLeaveNativeCartPageAlone()) {
    applyRootClasses();
    setCartAttributes();
    return;
  }

  applyRootClasses();
  ensureCartShell();
  installInterceptors();
  // Do not write cart attributes on every page load. Write them after ATC and before checkout only.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      applyRootClasses();
      ensureCartShell();
      installInterceptors();
    });
  }
})();
